import LoadingSkeleton from 'components/generic/LoadingSkeleton/LoadingSkeleton'
import { Box } from '@careguide/theme'
import { StickyContainer, Container } from '../Listing.style'
import Stack from '@careguide/stack'

const ListingLoadingSkeleton = () => (
  <Container flexDirection={{ _: 'column', tablet: 'row' }}>
    <Box flexBasis={{ _: '70%', tablet: '57%' }} mb={{ _: 6, tablet: 'unset' }}>
      <Box justifyContent='center' textAlign='center'>
        <LoadingSkeleton
          mt={5}
          mb={5}
          mr='auto'
          ml='auto'
          height='128px'
          width='128px'
          borderRadius='circle'
        />
        <Stack align='center' gap='4'>
          <LoadingSkeleton display='flex' minHeight='141px' minWidth='100%' />
          <LoadingSkeleton display='flex' minHeight='51px' minWidth='100%' />
          <LoadingSkeleton display='flex' minHeight={9} minWidth='100%' />
          <LoadingSkeleton display='flex' minHeight={9} minWidth='100%' />
          <LoadingSkeleton display='flex' minHeight={9} minWidth='100%' />
          <LoadingSkeleton display='flex' minHeight={9} minWidth='100%' mb={6} />
        </Stack>
      </Box>
    </Box>
    <Box display={{ _: 'none', tablet: 'block' }} flex='1' ml={{ _: 0, tablet: '3rem' }}>
      <StickyContainer $isSticky={false}>
        <LoadingSkeleton mt='20px' minHeight='29px' minWidth='100%' />
        <LoadingSkeleton mt='20px' minHeight='110px' minWidth='100%' />
        <LoadingSkeleton display='block' mt={2} minHeight='54px' minWidth='100%' />
        <LoadingSkeleton display='block' mt={2} minHeight='54px' minWidth='100%' />
      </StickyContainer>
    </Box>
  </Container>
)

export default ListingLoadingSkeleton
